/**
 * Тексти, потрібні на першому екрані: кнопка «Повідомити про проблему» (стани, меню, палітра), запасний
 * екран збою оболонки й тост, якщо чанк форми не завантажився. Тексти сторінок помилок — у
 * `support-pages.ts` (теж перший екран: `ErrorState` бере список), тексти форми — у `support.ts`
 * (лінивий `ReportDialog`): головний чанк їх не тягне.
 */
export const supportCore = {
  toHome: 'На початкову',
  rootTitle: 'Інтерфейс зупинився через помилку',
  rootText:
    'Перезавантажте сторінку. Чернетки карток, нових записів і підсумків зберігаються в цій вкладці.',
  reload: 'Перезавантажити',
  requestAccess: 'Попросити доступ',
  reportAction: 'Повідомити про проблему',
  reportLoadFailed: 'Не вдалося відкрити форму. Оновіть сторінку й спробуйте ще раз.',
  reportCommand: 'Повідомити про проблему',
  reportWords: ['помилка', 'збій', 'баг', 'підтримка', 'звернення', 'зворотний зв’язок'],
} as const;
